import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppButton from '@mysimpledb/shared/components/UI/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './VerifySuccess.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function VerifySuccess() {
  const query = useQuery();
  const navigate = useNavigate();

  const verified = query.get('verified') === '1';

  return (
    <main className="verify-success-page">
      <section
        className="verify-success-card"
        aria-labelledby="verify-success-title"
      >
        <div
          className={`verify-success-icon ${
            verified ? 'verify-success-icon--verified' : ''
          }`}
          aria-hidden="true"
        >
          <FontAwesomeIcon icon={verified ? faCircleCheck : faEnvelope} />
        </div>

        <div className="verify-success-heading">
          <div className="verify-success-eyebrow">Account verification</div>

          <h1 id="verify-success-title">
            {verified ? 'Email verified' : 'Verification complete'}
          </h1>

          <p>
            {verified
              ? 'Your email address has been verified successfully. You can now sign in to MySimpleDB.'
              : 'Your verification request has been completed. You can now sign in to MySimpleDB.'}
          </p>
        </div>

        <div className="verify-success-message">
          {verified
            ? 'Your account is ready to use.'
            : 'If you opened this page from your verification email, your next step is to sign in.'}
        </div>

        <div className="verify-success-actions">
          <AppButton
            variant="solid"
            size="md"
            onPress={() => navigate('/login?verified=1')}
            style={{ width: '100%' }}
          >
            Go to Login
          </AppButton>

          <div className="verify-success-divider">
            <span>or</span>
          </div>

          <AppButton
            variant="outline"
            size="md"
            onPress={() => navigate('/')}
            style={{ width: '100%' }}
          >
            Return Home
          </AppButton>
        </div>

        <div className="verify-success-help">
          If you did not request this verification, no action is required. You
          can safely close this page.
        </div>
      </section>
    </main>
  );
}
